import './App.css';
import Header from "./blocks/header";
import Dashboard from "./blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "./blocks/copyright";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import GroupsIcon from '@mui/icons-material/Groups';
import EventIcon from '@mui/icons-material/Event';
import DomainIcon from '@mui/icons-material/Domain';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {getAllVerifyResponse, getUserInfo} from "./store/logIn";


function App(props) {
    const {t, i18n} = useTranslation()
    const [is_main, setIsMain] = useState(false)
    const [is_other, setIsOther] = useState(false)
    const [is_district, setIsDistrict] = useState(false)

    useEffect(()=>{
        props.getUserInfo()
    }, [])

    useEffect(()=>{
        setIsMain(props.user.is_main)
        setIsOther(props.user.is_other)
        setIsDistrict(props.user.is_district)
    }, [props])

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}>
                    <Toolbar/>
                    <div className={'main'}>
                        {is_main
                            ?
                            <div className="row">
                                <div className="col-lg-3">
                                    <Link to={'/main/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <DomainIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('main')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={'/regions/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <LocationCityIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('other')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={'/districts/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <LocationCityIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('districts')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            :
                            is_other || is_district ?
                                <div className="row">
                                    <div className="col-lg-3">
                                        <Link to={'/my-department/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <DomainIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>
                                                        {is_district ? t('my_department_district') : t('my_department_region')}
                                                    </h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    {is_other && <div className="col-lg-3">
                                        <Link to={'/my-districts/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <LocationCityIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('district_branches')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>}
                                </div>
                                :
                                <div className="row">
                                    <div className="col-lg-3">
                                        <Link to={'/documents/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <FilePresentIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('required_documents')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">
                                        <Link to={'/problems/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <SyncProblemIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('problems')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">
                                        <Link to={'/workers/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <FolderSharedIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('list_employees')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">
                                        <Link to={'/members/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <GroupsIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('members')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">
                                        <Link to={'/stats/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <QueryStatsIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('stats')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">
                                        <Link to={'/events/'}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <EventIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('events')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                        }
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props=>props.login, {getAllVerifyResponse, getUserInfo})(App)